let dirPath = 'static/games/page006_game0';
let dirAudio = 'games/page006_game0/audio/';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  bruteForce: false,
  autoCheckAllCorrect: true,
  rulesGame: {
    // itemsConfig: { shuffle: true },
    otherProperty: {
      sounds: [{ src: dirAudio + 'click.mp3', id: 'mouseup' }],
    },
    items: [
      {
        itemsConfig: { shuffle: true },
        idGroup: 'left',
        idItem: 'con1',
        items: [{ idGroup: 'right', idItem: 'con1', correct: [{ idGroup: 'left', idItem: 'con1' }] }],
      },
      {
        itemsConfig: { shuffle: true },
        idGroup: 'left',
        idItem: 'con2',
        items: [{ idGroup: 'right', idItem: 'con3', correct: [{ idGroup: 'left', idItem: 'con2' }] }],
      },
      {
        itemsConfig: { shuffle: true },
        idGroup: 'left',
        idItem: 'con3',
        items: [{ idGroup: 'right', idItem: 'con4', correct: [{ idGroup: 'left', idItem: 'con3' }] }],
      },
      {
        itemsConfig: { shuffle: true },
        idGroup: 'left',
        idItem: 'con4',
        items: [{ idGroup: 'right', idItem: 'con2', correct: [{ idGroup: 'left', idItem: 'con4' }] }],
      },
    ],
  },
  layout: {
    itemsConfig: {
      background: {},
    },
    otherProperty: {
      // lines: {
      //   good: {
      //     hideLine: true,
      //   },
      //   connect: {
      //     color: '#239ad6',
      //     hideLine: true,
      //   },
      //   select: {
      //     color: '#239ad6',
      //     hideLine: true,
      //   },
      // },
      points: {
        pointMouse: {
          color: 'rgba(255,255,255,0.01)',
          rad: 10,
          alwaysShow: true,
        },
        itemsConfig: {
          alwaysShow: true,
          color: 'rgba(255,255,255,0.01)',
          positions: { rad: 10 },
        },
      },
      /*    lines: {

            connect: { color: 'black' }
          } */
    },
    groups: [
      {
        idGroup: 'left',
        positions: {
          autoFit: true,
          type: 'absolute',
          fixTab: [
            { x: 646, y: 828 }, // blue
            { x: 447, y: 853 }, // red
            { x: 543, y: 902 }, // yellow
            { x: 560, y: 774 }, // green
          ],
        },
        itemsConfig: {
          positions: { pos: { width: 180, height: 120 } },
          background: {
            color: 'rgba(255,255,255,0.01)',
            text: { font: 'Linotype', size: '50px', offset: { y: 6, x: 100 } },
          },
        },
        otherProperty: {
          points: {
            itemsConfig: { positions: { rad: 8 }, registrationPoint: { setTo: 'left' } },
            items: [{ id: 'p01', positions: { pos: { setTo: 'right' } } }],
          },
        },
        items: [
          {
            // blue
            id: 'con1',
            positions: { pos: { width: 110, height: 100 } },
            background: { color: 'rgba(255,255,255,0.01)' },
            otherProperty: {
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            // red
            id: 'con2',
            positions: { pos: { width: 102, height: 95 } },
            background: { color: 'rgba(255,255,255,0.01)' },
            otherProperty: {
              points: { itemsConfig: { positions: { offset: { x: 4, y: -8 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            // yellow
            id: 'con3',
            positions: { pos: { width: 140, height: 85 } },
            background: { color: 'rgba(255,255,255,0.01)' },
            otherProperty: {
              points: { itemsConfig: { positions: { offset: { x: 3, y: -19 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            // green
            id: 'con4',
            positions: { pos: { width: 128, height: 74 } },
            background: { color: 'rgba(255,255,255,0.01)' },
            otherProperty: {
              points: { itemsConfig: { positions: { offset: { y: -6 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
        ],
      },
      {
        idGroup: 'right',
        positions: {
          autoFit: true,
          type: 'absolute',
          fixTab: [
            { x: 1515, y: 163 },
            { x: 1515, y: 348 },
            { x: 1515, y: 534 },
            { x: 1515, y: 719 },
          ],
        },
        itemsConfig: {
          positions: { pos: { width: 268, height: 194 } },
          background: { image: { pos: { y: 0 } } },
        },
        otherProperty: {
          // lines: {
          //   good: {
          //     hideLine: true,
          //   },
          //   connect: {
          //     color: '#239ad6',
          //     hideLine: true,
          //   },
          //   select: {
          //     color: '#239ad6',
          //     hideLine: true,
          //   },
          // },
          points: {
            itemsConfig: { positions: { rad: 8 }, registrationPoint: { setTo: 'center' } },
            items: [{ id: 'p01', positions: { pos: { setTo: 'left' } } }],
          },
        },
        items: [
          {
            id: 'con1',
            // positions: { pos: { width: 268, height: 194 } },
            background: { color: 'rgba(255,255,255,0.01)', image: { src: dirPath + '/img/tubka_b.png' } },
            otherProperty: {
              audio: 'a01',
              points: { itemsConfig: { positions: { offset: { x: 1, y: 70 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            id: 'con2',
            // positions: { pos: { width: 268, height: 194 } },
            background: {
              color: 'rgba(255,255,255,0.01)',
              image: { src: dirPath + '/img/tubka_g.png' },
            },
            otherProperty: {
              audio: 'a04',
              points: { itemsConfig: { positions: { offset: { x: 1, y: 70 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            id: 'con3',
            // positions: { pos: { width: 268, height: 194 } },
            background: {
              color: 'rgba(255,255,255,0.01)',
              image: { src: dirPath + '/img/tubka_r.png' },
            },
            otherProperty: {
              audio: 'a02',
              points: { itemsConfig: { positions: { offset: { x: 1, y: 70 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
          {
            id: 'con4',
            // positions: { pos: { width: 268, height: 194 } },
            background: {
              color: 'rgba(255,255,255,0.01)',
              image: { src: dirPath + '/img/tubka_y.png' },
            },
            otherProperty: {
              audio: 'a03',
              points: { itemsConfig: { positions: { offset: { x: 1, y: 70 } } } },
              lines: {
                good: {
                  hideLine: true,
                  color: '#008000',
                },
                connect: {
                  color: '#ff0000',
                  hideLine: true,
                },
                select: {
                  color: '#ff0000',
                  hideLine: true,
                },
              },
            },
          },
        ],
      },
    ],
  },
};
let dataConfig = {
  mixinEngine: 'connect',
  fullscreen: true,
  mainImage: {
    imagePath: dirPath + '/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
  },
  mbAudioItemData: [
    {
      id: 'a01',
      src: dirAudio + '8_blue.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page006_game0/img/audioOn.png', iconOff: 'games/page006_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 23,
        x: 265,
      },
      width: '40px',
      height: '40px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: dirAudio + '9_red.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page006_game0/img/audioOn.png', iconOff: 'games/page006_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 23,
        x: 265,
      },
      width: '40px',
      height: '40px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: dirAudio + '10_yellow.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page006_game0/img/audioOn.png', iconOff: 'games/page006_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 23,
        x: 265,
      },
      width: '40px',
      height: '40px',
      unit: 'px',
    },
    {
      id: 'a04',
      src: dirAudio + '11_green.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page006_game0/img/audioOn.png', iconOff: 'games/page006_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 23,
        x: 265,
      },
      width: '40px',
      height: '40px',
      unit: 'px',
    },
  ],
  cssStyle: {
    overflow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
